export const MESSAGE_SOUNDS = [
  { id: 'classic', label: 'Обычный', url: '/incoming.wav' },
  { id: 'coin', label: 'Монетка по дереву', url: '/incoming-coin.wav' },
  { id: 'bell', label: 'Мягкий колокольчик', url: '/incoming-bell.wav' },
  { id: 'sheep', label: 'Овечка', url: '/incoming-sheep.wav' },
  { id: 'cowbell', label: 'Альпийская корова', url: '/incoming-cowbell.wav' },
  { id: 'kitten', label: 'Котёнок', url: '/incoming-kitten.wav' },
] as const;
export type MessageSound = typeof MESSAGE_SOUNDS[number]['id'];
export type SoundVolume = 0 | 1 | 2 | 3;
export const SOUND_LEVELS = [0, 0.2, 0.5, 1] as const;
export function readSoundPreferences(get: (key: string) => string | null, key: string): { tone: MessageSound; volume: SoundVolume } {
  try {
    const tone = get(`${key}:tone`), volume = get(`${key}:volume`);
    return {
      tone: MESSAGE_SOUNDS.find(sound => sound.id === tone)?.id ?? 'classic',
      volume: volume !== null && /^[0-3]$/.test(volume) ? Number(volume) as SoundVolume : 2,
    };
  } catch { return { tone: 'classic', volume: 2 }; }
}
